export default __webpack_public_path__ + "static/media/emergency.01dc7659.svg";